export default class AuditTemplatePageConstants {
    public static readonly BLOCK_ITEMS_PER_PAGE: number = 10;
    public static readonly LIST_ITEMS_PER_PAGE: number = 25;
}



// WEBPACK FOOTER //
// ./src/Constants/AuditTemplatePageConstants.ts